import React from 'react';

import { Miniatura } from './Miniatura';
import {
  excedente as calcularExcedente,
  proximas,
  type GaleriaFoto,
} from './helpers';

interface TrilhaProps {
  fotos: GaleriaFoto[];
  indice: number;
  onSelecionar: (indice: number) => void;
  onVerTodas: () => void;
}

/**
 * Coluna à direita do palco: as próximas fotos e, na quarta célula, o atalho
 * para a grade.
 *
 * A quantidade se ajusta sozinha a galerias pequenas — `proximas` nunca repete
 * a foto em cartaz, então com 3 fotos a trilha mostra 2 e o botão `+N` some
 * (o excedente é zero). Não há um segundo caminho de código para isso.
 */
export const Trilha: React.FC<TrilhaProps> = ({
  fotos,
  indice,
  onSelecionar,
  onVerTodas,
}) => {
  const miniaturas = proximas(fotos, indice);
  const excedente = calcularExcedente(fotos.length);

  if (miniaturas.length === 0) return null;

  return (
    <ul className="mpf-galeria__trilha">
      {miniaturas.map((foto) => (
        <li key={foto.key} className="mpf-galeria__trilha-item">
          <Miniatura foto={foto} onSelecionar={onSelecionar} />
        </li>
      ))}

      {excedente > 0 && (
        <li className="mpf-galeria__trilha-item">
          <button
            type="button"
            onClick={onVerTodas}
            aria-label={`Ver todas as ${fotos.length} fotos`}
            className="mpf-galeria__mais"
          >
            <span aria-hidden="true" className="mpf-galeria__mais-numero">
              +{excedente}
            </span>
            <span aria-hidden="true" className="mpf-galeria__mais-rotulo">
              ver todas
            </span>
          </button>
        </li>
      )}
    </ul>
  );
};

export default Trilha;
